// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPublicOfferCheckBusinessEntityModel, IMappers, TPublicOfferCheckBusinessEntityResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1PublicOfferCheckBusinessEntityResponse } from '../../../entities/response/PublicV1PublicOfferCheckBusinessEntityResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicOfferCheckBusinessEntityModel(): TPublicOfferCheckBusinessEntityModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/public-offer/check-business-entity/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IPublicOfferCheckBusinessEntityOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicOfferCheckBusinessEntity<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicOfferCheckBusinessEntityOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicOfferCheckBusinessEntityResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicOfferCheckBusinessEntityModel(),
    config,
  )) as FetchResponse<TPublicOfferCheckBusinessEntityResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1PublicOfferCheckBusinessEntityResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicOfferCheckBusinessEntityResponse>;
}
